import { useWebStoreContext } from "contexts";
import { useAppDispatch, useAppSelector, usePopupsState } from "hooks";
import { useLinks } from "hooks/useLinks";
import { ClubGiftsGaloreResponse } from "interfaces/club-gifts-galore-v2";
import { FeatureType } from "interfaces/feature-tracker";
import { useEffect } from "react";
import { useGetFeatureTrackerQuery } from "redux/apis";
import { useUpdatePopupStateMutation } from "redux/apis/clubGiftsGalore";
import { onOpenPopUp, selectDipState } from "redux/slices";

export const useClubGiftGalore = ({
	suppressPopups
}: {
	suppressPopups?: boolean;
}) => {
	const links = useLinks();
	const dispatch = useAppDispatch();
	const { authToken } = useWebStoreContext();
	const { triggerCached } = useAppSelector(selectDipState);
	const [updatePopupState] = useUpdatePopupStateMutation();
	const { isAnyPopupOpen, hasSeenRequiredPageTutorial, isSignupChecking } =
		usePopupsState();
	const isPopupsOpen = !!(
		!hasSeenRequiredPageTutorial ||
		isAnyPopupOpen ||
		triggerCached === "sessionStart" ||
		isSignupChecking
	);

	const {
		data
	}: {
		data?: ClubGiftsGaloreResponse;
	} = useGetFeatureTrackerQuery(
		{
			FeatureType: FeatureType.CLUB_GIFT_BONUS_V2,
			isAuthenticated: !!authToken?.value
		},
		{
			refetchOnFocus: !isPopupsOpen,
			pollingInterval: 10000,
			skip:
				window.location.pathname === links.club_shop.path || !authToken?.value
		}
	);

	const setPopupAsSeen = async (popupType: string) => {
		await updatePopupState({
			popupType
		});
	};

	// *Trigger not yet contributed popup
	useEffect(() => {
		const userClubTracker = data?.tracker?.userClubTracker;
		const activeTier = data?.tracker?.tiers[data?.tracker?.activeTierIndex];
		const hasNotEnoughClubMembers =
			data?.tracker?.tiers[data?.tracker?.activeTierIndex]?.numNewMembersNeeded;
		if (
			activeTier &&
			!!data?.tracker &&
			!isPopupsOpen &&
			!hasNotEnoughClubMembers &&
			userClubTracker?.eventContributionCount === 0 &&
			userClubTracker.isUserQualifiedToContribute &&
			!userClubTracker?.popupTrackers.noContributionPopupDisplayed &&
			window.location.pathname !== "/" &&
			window.location.pathname !== "/club-shop" &&
			!(suppressPopups && window.location.pathname === links.shop.path)
		) {
			setPopupAsSeen("no-contribution-popup-displayed");
			dispatch(onOpenPopUp("cgg-not-yet-contributed"));
		}
	}, [data?.tracker, isPopupsOpen, window.location.pathname, suppressPopups]);
};
